import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from 'react-oidc-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import { theme } from './components/commons/Context';

function getTenantFromHostname() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  return parts.length > 2 ? parts[0] : 'default';
}

const tenant = getTenantFromHostname();

const oidcConfig = {
  authority: `https://auth.praveya.com/realms/${tenant}`,
  client_id: 'praveya-web-frontend',
  loadUserInfo: true,
  redirect_uri: window.location.origin,
};

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider {...oidcConfig} onSigninCallback={() => {
    window.history.replaceState({}, document.title, window.location.pathname);
  }}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </AuthProvider>
);
